<!--  -->
<template>
  <div class="SyncOrderButton">
    <el-button-group>
      <el-button style="color: #b7b2bc" icon="el-icon-re@fresh" @click="tongBuStart()"
        v-if="buttonFlag">同步订单</el-button>
      <el-button style="color: #b7b2bc" icon="el-icon-refresh" disabled v-show="!buttonFlag" @click="tongBuStart"
        :loading="loadingPrint">同步中</el-button>
      <el-button style="text-align: center" icon="el-icon-more" @click="openTong">
      </el-button>
    </el-button-group>

    <el-dialog title="同步订单" :visible.sync="modal10" width="520px" top="15vh">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="按时间范围" name="name1">
          <el-form ref="form" :model="paramsTong" label-width="70px" size="small" class="sync-form">
            <el-form-item label="同步店铺">
              <shopNumber @shop-change="handleShopChange" />
            </el-form-item>

            <el-form-item label="创建时间">
              <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" style="width: 100%">
              </el-date-picker>
              <p style="color: #b7b2bc"> tip: 同步订单时间是根据订单创建时间判断的</p>
              <div class="time-shortcuts">
                <el-button type="text" size="mini" @click="setTimeRange(3)" :class="{ active: timeRangeDays === 3 }">近3天</el-button>
                <el-button type="text" size="mini" @click="setTimeRange(7)" :class="{ active: timeRangeDays === 7 }">近7天</el-button>
                <el-button type="text" size="mini" @click="setTimeRange(30)" :class="{ active: timeRangeDays === 30 }">近1月</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="按订单号" name="name2">
          <el-form ref="form" :model="paramsTong" label-width="70px" size="small" class="sync-form">
            <el-form-item label="同步店铺">
              <shopNumber @shop-change="handleShopChange" />
            </el-form-item>

            <el-form-item label="订单列表">
              <el-input type="textarea" :rows="4" placeholder="多个订单号用英文逗号分隔" v-model="paramsTongID">
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modal10 = false">取消</el-button>
        <el-button type="primary" v-if="buttonFlag" @click="modal10Ok">确定</el-button>
        <el-button disabled v-show="!buttonFlag" :loading="loadingPrint" icon="el-icon-refresh">同步中</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sync, getSyncProgressLog } from "@/api/option.js";
import shopNumber from "@/components/shopNumber.vue";
export default {
  components: { shopNumber },
  data() {
    return {
      activeTab: "name1",
      buttonFlag: true,
      loadingPrint: false,
      modal10: false,
      timeRange: [],
      timeRangeDays: 3,
      paramsTong: {
        orderStatus: null,
        orderIds: [],
        syncType: "MANUAL",
      },
      ShopIds: JSON.parse(localStorage.getItem("selectedShopIds") || "[]"),
      paramsTongID: "",
      timeShortcuts: [
        {
          text: "最近三天",
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 3);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "最近七天",
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 7);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "最近一个月",
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 1);
            picker.$emit("pick", [start, end]);
          }
        }
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleShopChange(selectedShopIds) {
      this.ShopIds = Array.isArray(selectedShopIds) ? [...selectedShopIds] : [];
    },
    openTong() {
      this.modal10 = true;
      this.paramsTongID = "";
      this.paramsTong.orderIds = [];
      this.setTimeRange(3);
    },
    setTimeRange(days) {
      this.timeRangeDays = days;
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - days);
      this.timeRange = [start, end];
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    tongBuStart() {
      const stored = JSON.parse(
        localStorage.getItem("selectedShopIds") || "[]"
      );
      const targetShopIds = this.ShopIds.length ? this.ShopIds : stored;
      this.loadingPrint = true;

      if (this.paramsTong.orderStatus == "") {
        this.paramsTong.orderStatus = null;
      }

      if (!this.timeRange || this.timeRange.length < 2) {
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - 3);
        this.timeRange = [start, end];
      }

      if (targetShopIds.length > 0) {
        const params = {
          shopNumbers: targetShopIds,
          startTime: this.formatDate(this.timeRange[0]),
          endTime: this.formatDate(this.timeRange[1]),
        };

        sync(params).then((res) => {
          if (res.data.code == 200) {
            this.tongDing();
            this.$message({
              type: "success",
              message: "开始同步",
            });
          } else {
            this.loadingPrint = false;
          }
        }).catch(() => {
          this.loadingPrint = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "暂未绑定店铺",
        });
      }
    },
    tongDing() {
      this.buttonFlag = false;
      var that = this;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        getSyncProgressLog().then((res) => {
          if (res.data.code == 200) {
            const status = res.data.data.status;
            if (status == "SUCCESS") {
              that.buttonFlag = true;
              that.loadingPrint = false;
              that.$message({
                type: "success",
                message: "同步完成",
              });
              clearInterval(that.timer);
              that.timer = null;
              that.$emit("sync-complete");
              window.dispatchEvent(new Event("sync-complete"));

            } else if (status == "PARTIAL_FAILED" || status == "FAILED") {
              that.buttonFlag = true;
              that.loadingPrint = false;
              that.$message({
                type: "error",
                message: "同步失败",
              });
              clearInterval(that.timer);
              that.timer = null;
            }
          }
        }).catch(() => {
          clearInterval(that.timer);
          that.timer = null;
        });
      }, 3000);
    },

    modal10Ok() {
      this.loadingPrint = true;

      if (this.paramsTong.orderStatus == "") {
        this.paramsTong.orderStatus = null;
      }

      const selectedShopIds = this.ShopIds.length
        ? this.ShopIds
        : JSON.parse(localStorage.getItem("selectedShopIds") || "[]");

      if (!selectedShopIds.length) {
        this.$message({
          type: "warning",
          message: "请选择至少一个店铺",
        });
        this.loadingPrint = false;
        return;
      }

      if (!this.timeRange || this.timeRange.length < 2) {
        this.$message({
          type: "warning",
          message: "请选择同步时间范围",
        });
        this.loadingPrint = false;
        return;
      }

      if (this.paramsTongID != "") {
        this.paramsTong.orderIds = this.paramsTongID.split(",");
      }

      const params = {
        shopNumbers: selectedShopIds,
        startTime: this.formatDate(this.timeRange[0]),
        endTime: this.formatDate(this.timeRange[1]),
        orderStatus: this.paramsTong.orderStatus,
        syncType: "MANUAL",
        orderIds: this.paramsTong.orderIds,
      };

      sync(params).then((res) => {
        if (res.data.code == 200) {
          this.tongDing();
          this.modal10 = false;
        } else {
          this.modal10 = false;
          this.loadingPrint = false;
        }
      }).catch(() => {
        this.modal10 = false;
        this.loadingPrint = false;
      });
    },
  },
  beforeCreate() { },
  created() { },
  beforeMount() { },
  mounted() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  deactivated() { },
};
</script>
<style lang="less" scoped>
.SyncOrderButton {
  width: 100%;
}

.sync-form {
  padding: 10px 0;
}

.sync-form .el-form-item {
  margin-bottom: 16px;
}

.sync-form .el-form-item:last-child {
  margin-bottom: 0;
}

.time-shortcuts {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  .el-button--text {
    padding: 4px 12px;
    font-size: 12px;
    color: #606266;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    &:hover {
      background-color: #f5f7fa;
      border-color: #c0c4cc;
    }
    
    &.active {
      background-color: #409eff;
      color: #fff;
      border-color: #409eff;
      
      &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
}

.dialog-footer {
  text-align: right;
  padding-top: 12px;
  border-top: 1px solid #ebf0f5;
}

.dialog-footer .el-button {
  margin-left: 8px;
}
</style>
